import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/content';
import { CTAButton } from './CTAButton';
export function BeforeAfter() {
  return <section className="w-full bg-navy-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-36" data-mp="3ogavnrgxf35u">
      <div className="mx-auto max-w-4xl" data-id="element-37" data-mp="3oi45ffmu63i2">
        <h2 className="text-center font-display text-3xl font-700 uppercase leading-tight text-white sm:text-4xl" data-id="element-38" data-mp="3sgbk84xqouqm">
          From clinical uncertainty…
          <br data-id="element-39" data-mp="3eo52ieexufp2" />
          <span className="text-gold-400" data-id="element-40" data-mp="3jgeqvq0en7p8">to a structured DVO process</span>
        </h2>

        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-41" data-mp="34rsd3sqfeo04">
          When a case involves severe wear, loss of tooth structure, aesthetic changes, or extensive
          rehabilitation, Vertical Dimension can become one of the most difficult areas to organize
          clinically.
        </p>

        <div className="mt-9 grid gap-5 md:grid-cols-2" data-id="element-42" data-mp="30ovo9kaalvnq">
          <div className="flex flex-col rounded-2xl border border-alert/30 bg-navy-950 p-5" data-id="element-43" data-mp="x4abt77drgyh">
            <h3 className="font-display text-xl font-700 uppercase tracking-wide text-alert" data-id="element-44" data-mp="t2ytznur000u">
              Before
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-45" data-mp="172zsiwnjivd5">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-46" data-mp="123di0uz3jt81">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-47" data-mp="121k7h4ld4our" />
                  <span className="text-sm leading-snug text-slate-300" data-id="element-48" data-mp="ebzowmt4ftm0">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-2xl border border-gold-500/40 bg-navy-950 p-5" data-id="element-49" data-mp="o45ejpvwhyy1">
            <h3 className="font-display text-xl font-700 uppercase tracking-wide text-gold-400" data-id="element-50" data-mp="jcvquutwx5os">
              After using DVO Master Protocol™
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-51" data-mp="3rqmaq6sl5ps5">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-52" data-mp="3mrrr52msnx6z">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-53" data-mp="1qpoeo2jtmnjy" />
                  <span className="text-sm leading-snug text-white" data-id="element-54" data-mp="1vosmaor3kd86">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-9 max-w-xl rounded-2xl border border-white/10 bg-navy-800 p-5 text-center" data-id="element-55" data-mp="24i4j97sdetmz">
          <p className="text-[11px] font-700 uppercase tracking-[0.2em] text-slate-400" data-id="element-56" data-mp="17s54gvlmmyvy">Go from</p>
          <p className="mt-1 text-base italic text-slate-300" data-id="element-57" data-mp="1cqosr2np0mrh">“I think this is the right approach…”</p>
          <p className="mt-4 text-[11px] font-700 uppercase tracking-[0.2em] text-gold-400" data-id="element-58" data-mp="1gs1xf9f1ujwt">To</p>
          <p className="mt-1 text-base font-600 text-white" data-id="element-59" data-mp="1ls6304ef5u89">
            “I know what I need to assess, document, and validate before moving forward.”
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-60" data-mp="2x6teiq6qw4qt">
          <CTAButton label="Yes, I want DVO Master Protocol™" subtext="One-time payment · Lifetime access · 7-day guarantee" data-id="element-61" data-mp="2x5i9kn1kcqy4" />
        </div>
      </div>
    </section>;
}